'use client'
import { formattedDateFullShort } from 'shared/timeHelper'
import { GameState } from 'types'

export function getDateLabel(
  ts: number,
  gamestate: GameState
): React.ReactElement | string {
  const date = new Date(ts).toISOString().split('T')[0]
  const today = new Date().toISOString().split('T')[0]
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const tomorrowISO = tomorrow.toISOString().split('T')[0]
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  const yesterdayISO = yesterday.toISOString().split('T')[0]

  if (gamestate === GameState.LIVE) {
    return 'JETZT LIVE'
  }

  if (date === today) {
    return 'HEUTE'
  } else if (date === tomorrowISO) {
    return 'MORGEN'
  } else if (date === yesterdayISO) {
    return 'GESTERN'
  }

  return formattedDateFullShort(ts)
}
